import * as API from '@/api/index'
/* 新增供应商 */
export const addSupplier = (params) => {
    return API.POST('/A02SupplierController/addSupplier', params)
}
/* 删除供应商 */
export const deleteSupplier = (params) => {
    return API.POST('/A02SupplierController/deleteSupplier', params)
}
/* 查询供应商 */
export const findSupplier = (params) => {
    return API.POST('/A02SupplierController/findSupplier', params)
}
/* 修改供应商 */
export const updateSupplier = (params) => {
    return API.POST('/A02SupplierController/updateSupplier', params)
}

/* 查询供应商类别标签 */
export const findSupplierTypeTag = (params) => {
    return API.POST('/A02SupplierController/findSupplierTypeTag', params)
}

/* 新增供应商类别标签 */
export const addSupplierTypeTag = (params) => {
    return API.POST('/A02SupplierController/addSupplierTypeTag', params)
}

/* 删除供应商类别标签 */
export const deleteSupplierTypeTag = (params) => {
    return API.POST('/A02SupplierController/deleteSupplierTypeTag', params)
}

/* 修改供应商类别标签 */
export const updateSupplierTypeTag = (params) => {
    return API.POST('/A02SupplierController/updateSupplierTypeTag', params)
}


/* 查询供应商性质标签 */
export const findSupplierNature = (params) => {
    return API.POST('/A02SupplierController/findSupplierNature', params)
}

/* 新增供应商性质标签 */
export const addSupplierNature = (params) => {
    return API.POST('/A02SupplierController/addSupplierNature', params)
}

/* 删除供应商性质标签 */
export const deleteSupplierNature = (params) => {
    return API.POST('/A02SupplierController/deleteSupplierNature', params)
}


/* 查询供应商性质标签 */
export const findSupplierBrand = (params) => {
    return API.POST('/A02SupplierController/findSupplierBrand', params)
}

/* 新增供应商性质标签 */
export const addSupplierBrand = (params) => {
    return API.POST('/A02SupplierController/addSupplierBrand', params)
}

/* 删除供应商性质标签 */
export const deleteSupplierBrand = (params) => {
    return API.POST('/A02SupplierController/deleteSupplierBrand', params)
}

/* 上传文件 */
export const filesUpload = (params) => {
    return API.POSTFILE('/A00CommonController/filesUploadNew', params)
}

